<form nz-form [formGroup]="formGroup" (ngSubmit)="submit()">
  <nz-row [nzGutter]="[24, 24]">
    <nz-col nzSpan="24">
      <div class="page-content-section">
        <fieldset>
          <legend>{{ 'Group Information' | translate | locale }}</legend>
          <nz-form-item *ngIf="mode === 'edit'">
            <nz-form-label
              [nzSm]="24"
              [nzXs]="24"
              nzRequired
              [nzNoColon]="true"
              nzFor="Code"
            >
              {{'Id' | translate}}
            </nz-form-label>
            <nz-form-control
              [nzSm]="24"
              [nzXs]="24"
              [nzErrorTip]="'Please insert the title of the group.' | translate"
            >
              <input nz-input formControlName="Id" id="Id" readonly />
            </nz-form-control>
          </nz-form-item>
          <nz-form-item>
            <nz-form-label
              [nzSm]="24"
              [nzXs]="24"
              nzRequired
              [nzNoColon]="true"
              nzFor="Code"
            >
              {{ 'Title' | translate | locale }}
            </nz-form-label>
            <nz-form-control
              [nzSm]="24"
              [nzXs]="24"
              [nzErrorTip]="'Please insert the attribute set id.' | translate"
            >
              <input nz-input formControlName="Title" id="Title" />
            </nz-form-control>
          </nz-form-item>
        </fieldset>
      </div>
    </nz-col>
    <nz-col nzSpan="24">
      <div class="page-content-section">
        <fieldset>
          <legend>{{ 'Group Properties' | translate | locale }}</legend>
          <ng-container formArrayName="DisplayProperties">
            <nz-table #propetiesTable [nzData]="propertiesArray.controls">
              <thead>
                <tr>
                  <th>#</th>
                  <th hidden>Id</th>
                  <th>{{'Code' | translate}}</th>
                  <th>{{'Title' | translate}}</th>
                  <th hidden>GroupId</th>
                  <th>{{'Default Value' | translate}}</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let property of propetiesTable.data; let i = index">
                  <td>{{ i + 1 }}</td>
                  <ng-container [formGroup]="property | AsFormGroup">
                    <td hidden>{{ property.value.Id }}</td>
                    <td>
                      <input
                        type="text"
                        nz-input
                        formControlName="Code"
                        (focus)="valueChanged()"
                      />
                    </td>
                    <td>
                      <input type="text" nz-input formControlName="Title" />
                    </td>
                    <td hidden>{{ property.value.GroupId }}</td>
                    <td>
                      <nz-select
                      [nzAllowClear]="true"
                        formControlName="DefaultValue"
                        style="width: 100%"
                        (nzOpenChange)="valueChanged()"
                      >
                        <nz-option [nzValue]="true" [nzLabel]="'Yes' | translate"></nz-option>
                        <nz-option [nzValue]="false" [nzLabel]="'No' | translate"></nz-option>
                      </nz-select>
                    </td>
                  </ng-container>
                  <td>
                    <button
                      nz-button
                      nzDanger
                      nz-popconfirm
                      nzShape="circle"
                      [nzPopconfirmTitle]="
                        'Are you sure deleting this property?' | translate | locale
                      "
                      (nzOnConfirm)="deletePropertyLine(property.value)"
                    >
                      <i class="fal fa-trash"></i>
                    </button>
                  </td>
                </tr>
              </tbody>
            </nz-table>
            <div style="text-align: center">
              <button nz-button type="button" (click)="addPropertyLine()">
                <nz-space>
                  <i *nzSpaceItem class="fal fa-plus-circle"></i>
                  <span *nzSpaceItem>{{ 'Add New Property' | translate | locale }}</span>
                </nz-space>
              </button>
            </div>
          </ng-container>
        </fieldset>
      </div>
    </nz-col>
  </nz-row>
</form>
